/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_HeadingInputs */

const zh_pricing_heading = /** @type {(inputs: Pricing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择适合你的方案`)
};

const en_pricing_heading = /** @type {(inputs: Pricing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the Right Plan for You`)
};

const es_pricing_heading = /** @type {(inputs: Pricing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige el Plan Adecuado para Ti`)
};

/**
* | output |
* | --- |
* | "Choose the Right Plan for You" |
*
* @param {Pricing_HeadingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_heading = /** @type {((inputs?: Pricing_HeadingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_HeadingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_heading(inputs)
	if (locale === "en") return en_pricing_heading(inputs)
	return es_pricing_heading(inputs)
});